import { useEffect, useState } from "react";

const navs = [
  { id: "live", label: "实时热搜" },
  { id: "ranking", label: "热度排行" },
  { id: "category", label: "分类专区" },
  { id: "hotpick", label: "爆款瓜料" },
  { id: "about", label: "关于我们" },
  { id: "faq", label: "常见问题" },
];

function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur-md shadow-sm" : "bg-background-50/60 backdrop-blur-sm"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4 md:px-6">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-lg font-bold text-foreground-950">吃瓜合集</span>
            <span className="text-[10px] font-medium text-primary-600 tracking-widest">TRENDING BOARD</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navs.map((n) => (
            <button
              key={n.id}
              onClick={() => scrollToId(n.id)}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition hover:bg-primary-100 hover:text-primary-700"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <button
          onClick={() => scrollToId("hotpick")}
          className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600 md:inline-flex"
        >
          看今日瓜
        </button>

        <button
          onClick={() => setOpen(!open)}
          aria-label="打开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-200 md:hidden"
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navs.map((n) => (
              <button
                key={n.id}
                onClick={() => {
                  setOpen(false);
                  setTimeout(() => scrollToId(n.id), 50);
                }}
                className="rounded-md px-3 py-2.5 text-left text-sm font-medium text-foreground-800 transition hover:bg-primary-100 hover:text-primary-700"
              >
                {n.label}
              </button>
            ))}
            <button
              onClick={() => {
                setOpen(false);
                setTimeout(() => scrollToId("hotpick"), 50);
              }}
              className="mt-1 whitespace-nowrap rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50"
            >
              看今日瓜
            </button>
          </div>
        </div>
      )}
    </header>
  );
}